import { Component, OnInit } from "@angular/core";
import {
  MonitoringAvailabilityZoneInfo,
  MonitoringStatusViewModel,
} from "./monitoring-status.view-model";
import { UserService } from "../../../domain/user-service";
import { IMonitoringRepository } from "../../../domain/monitoring/monitoring-repository";
import { ReportsService } from "../../../services/reports.service";

@Component({
  selector: "evrideo-status",
  templateUrl: "./monitoring-status.component.html",
  styleUrls: ["./monitoring-status.component.scss"],
})
export class MonitoringStatusComponent implements OnInit {
  constructor(
    private _userService: UserService,
    private _monitoringRepository: IMonitoringRepository,
    private _reportService: ReportsService,
  ) {}

  vm: MonitoringStatusViewModel;

  ngOnInit(): void {
    if (!MonitoringStatusViewModel.LastState) {
      MonitoringStatusViewModel.LastState = new MonitoringStatusViewModel(
        this._reportService,
        this._monitoringRepository,
      );
    }
    this.vm = MonitoringStatusViewModel.LastState;

    this.vm.OnInit();
  }
}
